// extracted by mini-css-extract-plugin
export var centered = "_9-6";
export var flexible = "_9-5";
export var footer = "_9-k";
export var footerBorder = "_9-l";
export var header = "_9-c";
export var headerBorder = "_9-d";
export var headerDefault = "_9-g";
export var headerMedium = "_9-h";
export var headerPadding = "_9-e";
export var iconAndTitle = "_9-f";
export var large = "_9-4";
export var largePadding = "_9-a";
export var medium = "_9-3";
export var mediumPadding = "_9-9";
export var modal = "_9-0";
export var modalContainer = "_9-b";
export var noPadding = "_9-7";
export var skinny = "_9-1";
export var small = "_9-2";
export var smallPadding = "_9-8";
export var subtitle = "_9-j";
export var title = "_9-i";